<template>
    <div>
        <div v-show='show' class='layer-pop square'>
            <div class='view-content small-padding' style='width: auto; max-width: 90vw'>
                <button class='close' @click='onClosePop'>
                    <span class='blind'>Popup Close</span>
                </button>
                <div class='com-scroll-y'>
                    <p class='pop-tit'>계약서 미리보기</p>
                    <div style='display: flex'>
                        <div class='contract-preview' style='margin-top: 15px'>
                            <div class='contract-content' style='padding: 0'>
                                <el-carousel
                                    ref="carousel"
                                    trigger="click"
                                    :interval="1000"
                                    :arrow="contractList.length > 1 ? 'always' : 'none'"
                                    :autoplay="autoPlay"
                                    :indicator-position="'none'"
                                    style="height: 100%;"
                                >
                                    <el-carousel-item
                                        style='padding: 30px'
                                        v-for="(item, index) in contractList"
                                        :key="index"
                                    >
                                        <div class='contract-content-info'>
                                            <div class='contract-title-input' style='margin-bottom: 20px; background-color: white'>
                                                {{item.e_contract_title}}
                                            </div>
                                            <div class='contract-info-title'>수신인 정보</div>
                                            <div style='display: flex'>
                                                <div class='contract-info-sub-title title'>이름</div>
                                                <div class='contract-info-sub-title' v-show='templateSendId > 0'>{{item.recipientName}}</div>
                                            </div>
                                            <div style='display: flex'>
                                                <div class='contract-info-sub-title title'>연락처</div>
                                                <div class='contract-info-sub-title' v-show='templateSendId > 0'>{{item.recipientPhone | phoneNumberFilter }}</div>
                                            </div>
                                            <div v-show='item.ticketInfo != undefined'>
                                            <div class='contract-info-title' v-show='item.e_contract_member_type == "M"'>이용권 정보</div>
                                                <div v-show='templateSendId > 0 && item.e_contract_member_type == "M"'>
                                                    <div v-for='(ticketInfo, index) in (item.ticketInfo != undefined ? JSON.parse(item.ticketInfo) : [])' :key='index' class='ticket-container'>
                                                        <div class='ticket-box'>
                                                            <div class='ticket-box-title'>{{ticketInfo.title}}</div>
                                                            <div class='ticket-box-info'>
                                                                <div style='flex: 1'>
                                                                    {{ticketInfo.period}}
                                                                </div>
                                                                <div>
                                                                    {{ticketInfo.price}}원
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
<!--                                                <div class='contract-info-sub-title' v-show='templateSendId > 0 && item.e_contract_member_type == "M"'>{{item.ticketSendCount + "/" + item.ticketSendPrice}}</div>-->
<!--                                                <div class='contract-info-sub-title' v-show='templateSendId > 0 && item.e_contract_member_type == "M"'>{{item.ticketAvailableCount}} 건</div>-->
                                            </div>
                                            <div class='contract-info-title'>약관</div>
                                            <div style='padding: 10px 10px 0 10px' v-for='(it, i) in item.templateInfo'>
                                                <div v-if='it.type == 1'>
                                                    <div class='contract-info-sub-title' style='display: flex'>
                                                        <div style='flex: 1;'>{{it.title}}</div>
                                                    </div>
                                                    <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent; color: #333333' disabled>{{it.content}}</textarea>
                                                </div>
                                                <div v-else style='display: flex'>
<!--                                                    <div class='com-check' style='margin-top: 12px'>-->
<!--                                                        <input-->
<!--                                                            :id='`agree-check-${index}-${i}`'-->
<!--                                                            name='check-c1'-->
<!--                                                            type='checkbox'-->
<!--                                                            disabled-->
<!--                                                        />-->
<!--                                                        <label :for='`agree-check-${index}-${i}`' class='agree-option' style='cursor: default'></label>-->
<!--                                                    </div>-->
                                                    <div style='flex: 1;'>
                                                        <div class='contract-info-sub-title' style='display: flex'>
                                                            <div style='flex: 1;'>{{it.title}}</div>
                                                        </div>
                                                        <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent; color: #333333' disabled>{{it.content}}</textarea>
                                                        <div v-for='(jt, j) in it.options' style='display: flex; align-items: center; margin-top: 10px'>
                                                            <div class='com-check'>
                                                                <input
                                                                    v-if='jt.checked'
                                                                    :id='`agree-check-${index}-${i}-${j}`'
                                                                    name='check-c1'
                                                                    type='checkbox'
                                                                    disabled
                                                                    checked
                                                                />
                                                                <input v-else
                                                                       :id='`agree-check-${index}-${i}-${j}`'
                                                                       name='check-c1'
                                                                       type='checkbox'
                                                                       disabled
                                                                />
                                                                <label :for='`agree-check-${index}-${i}-${j}`' class='agree-option' style='cursor: default'><div v-show='it.requiredFlag' class='check-required'>*</div></label>
                                                            </div>
                                                            <div class='agree-option-input'>{{jt.title}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style='display: flex'>
                                                <div class='contract-info-title' style='flex: 1;'>{{(templateSendId > 0 ? item.sendTime : new Date()) | dateFormatFilter2}}</div>
                                                <div style='width: 300px; margin-top: 40px;'>
                                                    <div style='display: flex; align-items: center'>
                                                        <div class='contract-info-person'>{{item.recipientName ? "수신인 : " + item.recipientName : "수신인"}}</div>
                                                        <div class='contract-info-signature no-image' v-show='!(templateSendId > 0)'>(서명)</div>
                                                        <img class='contract-info-signature' v-show='templateSendId > 0' :src='recipientSignImageUrl[index]' />
                                                    </div>
                                                    <div style='display: flex; align-items: center; margin-top: 10px;'>
                                                        <div class='contract-info-person'>발신인 {{item.centerName ? (": " + item.centerName) : ""}}</div>
                                                        <div v-if='senderSignImageUrl[index] === ""' class='contract-info-signature no-image'>(서명)</div>
                                                        <img v-else class='contract-info-signature' :src='senderSignImageUrl[index]' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                    </div>
                    <div class='bottom-btn' style='margin-top: 30px; padding-bottom: 0'>
                        <button class='com-btn' @click='onClosePop'>닫기</button>
                        <button class='com-btn blue' @click='onPDFDownload'>PDF 다운로드</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';

export default {
    name: 'ContractPreviewDlg',
    props: {
        templateSendId: Number,
        templateId: Number,
        show: Boolean,
        close: Function,
    },
    data() {
        return {
            centerId: 0,

            contractList: [],
            recipientSignImageUrl: [],
            senderSignImageUrl: [],
            autoPlay: false,

            centerInfo: {},
            senderSignImageRawData: "",
        };

    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const {getters} = this.$store;
            return getters['auth/staffId'];
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.centerId = parseInt(this.cId); // 센터id

            await this.getCenterInfo();

            await this.getSignatureList();

            Promise.all([
                this.getTemplate(),
            ]).then((response) => {
                if (response && response.length > 0) {
                    this.contractList = response[0].data;
                    if (this.contractList && this.contractList.length > 0) {
                        this.contractList.map(item => {
                            item.centerName = this.centerInfo.centerName;

                            if (item.senderSignImageUrl === undefined || item.senderSignImageUrl === "") {
                                this.senderSignImageUrl.push(this.senderSignImageRawData);
                            } else {
                                // this.senderSignImageUrl.push(item.senderSignImageUrl)
                                convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                                    this.senderSignImageUrl.push(imageRawData);
                                })
                            }
                            if (item.recipientSignImageUrl !== "") {
                                //this.recipientSignImageUrl.push(item.recipientSignImageUrl);
                                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                                    this.recipientSignImageUrl.push(imageRawData);
                                })
                            }
                        })
                    }

                    this.autoHeightTextArea();
                }
            })
        },

        async getSignatureList() {
            try {
                this.isLoading = true;

                const response = await api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature`);
                if (response && response.data) {
                    response.data.map(item => {
                        if (item.s_rep) {
                            this.fileGroupId = item.s_file_group_id;
                            // this.senderSignImageRawData = item.f_file_url;
                            convertImgToDataURLviaCanvas(item.f_file_url, (imgRawData) => {
                                this.senderSignImageRawData = imgRawData
                            })
                        }
                    })
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        onClosePop() {
            this.close();
        },

        onPDFDownload() {

            setTimeout(() => {
                let element = document.createElement("div");
                element.style.padding = "20px";

                let contract = document.querySelector(".contract-content-info");
                let html = contract.innerHTML.toString().replace(new RegExp("textarea", 'g'), "div");
                html = html.toString().replace(new RegExp("\n", 'g'), "<br>");
                element.innerHTML = html;

                let filename = this.contractList[0].e_contract_title + '.pdf';
                if (this.contractList[0].recipientName) {
                    filename = this.contractList[0].e_contract_title + '(' + this.contractList[0].recipientName + ').pdf';
                }

                // 임시로 DOM에 추가
                document.body.appendChild(element);
                let opt = {
                    filename: filename,
                    enableLinks: true,
                    image: { type: 'jpeg', quality: 0.98 },
                    pagebreak: { mode: 'avoid-all' },
                    html2canvas: {
                        scale: 3,
                        y: 0,
                        scrollY: 0,
                        useCORS: true,
                        width: 800,
                        letterRendering: true,
                        allowTaint: false, //useCORS를 true로 설정 시 반드시 allowTaint를 false처리 해주어야함
                    },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                }

                html2pdf().from(element).set(opt).save();
                // DOM에서 제거
                document.body.removeChild(element);

                this.close();
            }, 1);
        },
        getTemplate() {
            if (this.templateSendId !== undefined) {
                return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/send/${this.templateSendId}`);
            }
            if (this.templateId !== undefined) {
                return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/origin/${this.templateId}`);
            }

            return null
        },

        autoHeightTextArea() {
            setTimeout(() => {
                let areas = document.querySelectorAll("textarea");
                for (var i = 0; i < areas.length; i++) {
                    areas.item(i).style.height = "auto"
                    areas.item(i).style.height = areas.item(i).scrollHeight + "px"
                }
            }, 10)
        },
    },
};
</script>
